import { Row, Col } from 'reactstrap';
import OnboardingTable from 'components/templates/rpm/practice/onboardingStatus/patientsTable';
import OnboardingStatusCount from 'components/molecules/onboarding-status-count';
import {
  useOnboardingStatus,
  useOnboardingStatusQueryFilter,
  useOnboardingStatusReport,
  useSendReport,
} from 'infrastructure/hooks/rpm/onboarding-status-report';
import OnboardingStatusGraphs from 'components/molecules/onboarding-status-count/graphs';
import { ModuleType } from 'infrastructure/enums';
import OnboardingNavigationHeader from 'components/molecules/onboarding-status-header';
import { useTranslation } from 'react-i18next';
import RpmOnboardingFilter from 'components/templates/rpm/practice/onboardingStatus/filter';

import s from './styles.module.scss';

const OnboardingStatus = () => {
  const { filter } = useOnboardingStatusQueryFilter();
  const { data, isLoading } = useOnboardingStatus(filter);
  const { patients, patientsLoading } = useOnboardingStatusReport(filter);
  const { sendReport, sendLoading } = useSendReport();
  const { t } = useTranslation();

  return (
    <div>
      <OnboardingNavigationHeader
        hasPatients={Boolean(patients.patients?.length)}
        totalPatients={data?.statuses.total}
        title={t('labels.rpmOnboardingStatusReport')}
        loading={sendLoading}
        onClick={() => {
          sendReport(filter);
        }}
      />
      <div className={s.body}>
        <OnboardingStatusCount
          statuses={data?.statuses}
          loading={isLoading}
          module={ModuleType.RPM}
        />
        <OnboardingStatusGraphs
          statusBlocks={data?.statuses}
          insuranceBlocks={data?.insurances ?? []}
          loading={isLoading}
          module={ModuleType.RPM}
        />
        <RpmOnboardingFilter />
        <Row>
          <Col xs="12">
            <OnboardingTable
              patients={patients?.patients ?? []}
              count={patients?.patientCount}
              loading={patientsLoading}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default OnboardingStatus;
